import { AvatarComposite } from '@/shared/ui/AvatarComposite'

export function CosmeticPreviewStack({
  backgroundUrl,
  avatarUrl,
  frameUrl,
  nameHint,
  compact = false,
  className
}: {
  backgroundUrl: string | null
  avatarUrl: string
  frameUrl: string | null
  nameHint: string
  compact?: boolean
  className?: string
}) {
  return (
    <AvatarComposite
      backgroundUrl={backgroundUrl}
      avatarUrl={avatarUrl}
      frameUrl={frameUrl}
      size={compact ? 'md' : 'lg'}
      className={className}
      aria-label={`Pré-visualização: ${nameHint}`}
    />
  )
}
